var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeEducate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 196,
    viewBox: "0 0 205 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_105)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 205,
    height: 196
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.24 0H0.0299988V195.27H204.24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.26 116.24V47.0601",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42 136.46L184.77 147.85L195.53 137.83C198.64 135 198.86 130.18 196.03 127.07C195.9 126.93 195.76 126.79 195.62 126.65L184.77 116.24L173.36 128.04C171.05 129.84 170.64 133.18 172.44 135.49C172.72 135.86 173.06 136.18 173.43 136.46H173.42Z",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26 168.25V147.31",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 39.83L100.58 3.92004L200.78 39.83L100.58 75.74L3.5 39.83Z",
    stroke: "#41BBE8",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.91 108.65C39.91 113.44 42.19 117.66 45.54 119.09C49 120.56 52.85 122.08 53.33 122.28C61.6 125.77 64.29 126.94 72.85 128.81C98.08 134.34 130.16 133.85 153.71 119.97C157.22 117.9 159.53 113.23 159.53 108.01V55.65L100.54 76.48L39.91 53.66V108.65Z",
    stroke: "#41BBE8",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204.28,
    height: 195.27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeEducate);
export default __webpack_public_path__ + "static/media/WeEducate.3c0109e251cdc7e76c59d6a2d5fe8379.svg";
export { ForwardRef as ReactComponent };